import { useEffect, useState } from "react";

const IMAGES_COUNT = 5;

export default function useHeroImage() {
  const [index, setIndex] = useState(-1);

  useEffect(() => setIndex(Math.floor(Math.random() * IMAGES_COUNT)), []);

  return index;
}
